<span class="d-block">{{ step8.getspan11 | translate }}</span>
<span class="d-block">{{ step8.getspan12 | translate }}</span><br>

<app-form-input
*ngIf="isDocConsultation()"
[parentForm]="parentForm"
[disabled]="disabled"
[value]="''"
[isChecked]="justifications.docsConsultation"
[label]="step8.getdocsconsultation"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_docsConsultation'">
</app-form-input><br>

<span class="d-block">{{ step8.getspan13 | translate }}</span><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.redressementJudiciaire"
[label]="step8.getredressementjudiciaire"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_redressementJudiciaire'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.article2141"

[label]="step8.getarticle2141"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_article2141'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.articlesL5212"

[label]="step8.getarticlesl5212"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_articlesL5212'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.articlesL1221L3243"

[label]="step8.getarticlesl1221l3243"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_articlesL1221L3243'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.articleL3243"

[label]="step8.getarticlel3243"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_articleL3243'">
</app-form-input><br>

<span class="d-block">{{ step8.getspan14 | translate }}</span><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.chiffresAffaires"

[label]="step8.getchiffresaffaires"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_chiffresAffaires'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.risquesProfessionels"

[label]="step8.getrisquesprofessionels"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_risquesProfessionels'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.bilans"

[label]="step8.getbilans"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_bilans'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.effectifs"

[label]="step8.geteffectifs"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_effectifs'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.listeFournituresServices"

[label]="step8.getlistefournituresservices"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_listeFournituresServices'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.listeTravaux"

[label]="step8.getlistetravaux"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_listeTravaux'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.indicationTitresOperateur"

[label]="step8.getindicationtitresoperateur"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_indicationTitresOperateur'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.indicationTitresCadres"

[label]="step8.getindicationtitrescadres"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_indicationTitresCadres'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.equipementTechnique"

[label]="step8.getequipementtechnique"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_equipementTechnique'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.equipementFournituresServices"

[label]="step8.getequipementfournituresservices"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_equipementFournituresServices'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="justifications.qualificationsProfessionnelles?.precisions"
[label]="step8.getqualificationsprofessionnelles"
[type]="'checkbox'"
[checkboxDestination]="'object'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_qualificationsProfessionnellesCB'">
</app-form-input><br>

<app-qualifications-professionnelles *ngIf="qualificationsProfessionnelles()"  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [qualificationsProfessionnelles]="justifications.qualificationsProfessionnelles"><br></app-qualifications-professionnelles>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="justifications.conformiteFournitures?.precisions"
[label]="step8.getconformitefournitures"
[type]="'checkbox'"
[checkboxDestination]="'object'" [rule]="''"
[name]="getUid()+'_SepAtt_conformiteFournituresCB'">
</app-form-input><br>

<app-conformite-fournitures *ngIf="conformiteFournitures()" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [conformiteFournitures]="justifications.conformiteFournitures"><br></app-conformite-fournitures>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.detailFournitures"

[label]="step8.getdetailfournitures"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_detailFournitures'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.defenseNationaliteCandidat"

[label]="step8.getdefensenationalitecandidat"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_defenseNationaliteCandidat'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.defenseHabilitationSecret"

[label]="step8.getdefensehabilitationsecret"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_defenseHabilitationSecret'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="justifications.autorisationSpecifique?.precisions"
[label]="step8.getautorisationspecifique"
[type]="'checkbox'"
[checkboxDestination]="'object'" [rule]="''"
[name]="getUid()+'_SepAtt_autorisationSpecifiqueCB'">
</app-form-input><br>

<app-autorisation-specifique *ngIf="autorisationSpecifique()" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [autorisationSpecifique]="justifications.autorisationSpecifique"><br></app-autorisation-specifique>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.dc1"

[label]="step8.getdc1"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="''"
[name]="getUid()+'_SepAtt_dC1'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.dc2"

[label]="step8.getdc2"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="''"
[name]="getUid()+'_SepAtt_dC2'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.dc3"

[label]="step8.getdc3"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="''"
[name]="getUid()+'_SepAtt_dC3'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.dc4"

[label]="step8.getdc4"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="''"
[name]="getUid()+'_SepAtt_dC4'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.documentsAutreOperateur"

[label]="step8.getdocumentsautreoperateur"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_documentsAutreOperateur'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.traductionFrancaiseCandidat"

[label]="step8.gettraductionfrancaisecandidat"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_traductionFrancaiseCandidat'">
</app-form-input><br>

<span class="d-block">{{ step8.getspan15 | translate }}</span><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.articlesD8222"

[label]="step8.getarticlesd8222"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_articlesD8222'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.attestationObligationsFiscales"

[label]="step8.getattestationobligationsfiscales"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_attestationObligationsFiscales'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.certificatPaysOrigine"

[label]="step8.getcertificatpaysorigine"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_certificatPaysOrigine'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="''"
[isChecked]="justifications.traductionFrancaiseAttributaire"

[label]="step8.gettraductionfrancaiseattributaire"
[type]="'checkbox'"
[checkboxDestination]="'string'" [rule]="'pattern_29'"
[name]="getUid()+'_SepAtt_traductionFrancaiseAttributaire'">
</app-form-input><br>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="justifications.justificationAutre"
[label]="step8.getjustificationautre"
[type]="'checkbox'"
[checkboxDestination]="'object'" [rule]="''"
[name]="getUid()+'_SepAtt_justificationAutreCB'">
</app-form-input><br>

<div *ngIf="isJustificationAutre()">
	<app-form-input  [label]=""
		[name]="getUid() + '_SepAtt_justificationAutre'" [parentForm]="parentForm" [disabled]="disabled"
		[type]="'chips'" [rule]="'maxSize_2000'" [value]="justifications.justificationAutre">
	</app-form-input>
	<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
</div>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="justifications.justificationComment"
[label]="step8.getjustificationcomment"
[type]="'text'"
[rule]="'minSize_5|maxSize_2000'"
[name]="getUid()+'_SepAtt_justificationComment'">
</app-form-input>
